import React, { useEffect, useState } from 'react';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';
import './AllLostItems.css';

const AllLostItems = () => {
  const [lostItems, setLostItems] = useState([]);

  const formatDate = (value) => {
    try {
      if (!value) return 'N/A';
      if (typeof value === 'string') return value;
      if (value.toDate) return value.toDate().toLocaleString();
      return new Date(value.seconds * 1000).toLocaleString();
    } catch {
      return 'Invalid date';
    }
  };

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'lostItems'));
        const items = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setLostItems(items);
      } catch (error) {
        console.error('❌ Error fetching lost items:', error);
      }
    };

    fetchItems();
  }, []);

  const handleClaim = async (itemId) => {
    const confirm = window.confirm('Do you want to claim this item?');
    if (!confirm) return;

    try {
      const itemRef = doc(db, 'lostItems', itemId);
      await updateDoc(itemRef, { itemStatus: 'Claim Requested' });
      setLostItems(prev =>
        prev.map(item => item.id === itemId ? { ...item, itemStatus: 'Claim Requested' } : item)
      );
      alert('✅ Your claim has been submitted to the admin.');
    } catch (error) {
      console.error('❌ Error submitting claim:', error);
      alert('❌ Failed to submit claim.');
    }
  };

  return (
    <div className="all-lost-items-container">
      <h2>📦 Reported Lost Items</h2>
      {lostItems.length === 0 ? (
        <p>No lost items reported yet.</p>
      ) : (
        <ul className="items-list">
          {lostItems.map(item => (
            <li key={item.id} className="item-card">
              <h3>{item.itemName || 'Unnamed Item'}</h3>

              {/* ✅ Display base64 image */}
              {item.imageUrl && (
                <img
                  src={item.imageUrl}
                  alt={item.itemName || 'Uploaded Item'}
                  style={{
                    width: '100%',
                    maxWidth: '250px',
                    height: 'auto',
                    borderRadius: '10px',
                    marginBottom: '1rem',
                  }}
                />
              )}

              <p><strong>Status:</strong> <span style={{ color: item.itemStatus === 'Found' ? 'green' : item.itemStatus === 'Lost' ? 'red' : 'orange' }}>{item.itemStatus || 'N/A'}</span></p>
              <p><strong>Date:</strong> {formatDate(item.dateLost)}</p>
              <p><strong>Description:</strong> {item.description || 'N/A'}</p>
              <p><strong>Location:</strong> {item.location || 'N/A'}</p>
              <p><strong>Reported By:</strong> {item.yourName || 'Anonymous'}</p>
              {item.message && <p><strong>Message:</strong> {item.message}</p>}

              {item.itemStatus === 'Found' && (
                <button
                  onClick={() => handleClaim(item.id)}
                  style={{
                    marginTop: '0.5rem',
                    backgroundColor: '#1B3B6F',
                    color: 'white',
                    padding: '0.5rem 1rem',
                    border: 'none',
                    borderRadius: '5px'
                  }}
                >
                  Claim Item
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AllLostItems;
